'use client';

import CarModelEngineDesktop from './Desktop/CarModelEngineDesktop';
import { useRef, useState } from 'react';
import Mobile from './Mobile/CarModelEngineMobile';

export default function CarModelEngine({ fields }) {
  const [dataState, setDataStet] = useState(fields);
  const swiperRef = useRef(null);
  const swiperRefMobile = useRef(null);
  const marks = fields.marks;
  const updateMarks = (id) => {
    setDataStet((prev) => ({
      ...prev,
      marks: prev.marks.map((mark) => ({
        ...mark,
        open: mark.fields.index.value === id,
      })),
    }));
  };

  const handleClickMark = (id) => {
    swiperRef.current?.slideTo(id - 1);
    swiperRefMobile.current?.slideTo(id - 1);
    updateMarks(id);
  };

  const handleClose = () => {
    updateMarks(null);
  };

  const setSlideIndex = (index) => {
    swiperRef.current?.slideTo(index);
    swiperRefMobile.current?.slideTo(index);
    updateMarks(index + 1);
  };

  return (
    <div className={'container car-model-engine'}>
      <CarModelEngineDesktop
        data={dataState}
        swiperRef={swiperRef}
        onClickMark={handleClickMark}
        onClose={handleClose}
        setSlideIndex={setSlideIndex}
      />
      <Mobile
        data={dataState}
        swiperRef={swiperRefMobile}
        onClickMark={handleClickMark}
        onClose={handleClose}
        setSlideIndex={setSlideIndex}
      />
    </div>
  );
}
